<!-- <p>badminton-tournament works!</p> -->

<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1> Chess Championship</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
	<div class="container">
        <div class="sec-title text-center">
			<h2>G H Raisoni Sports and cultural foundation   <span >and Kalpana Prakash Welfare foundation  </span></h2>
		</div>

		<div class="row text-justify">
            <div class="col-lg-12">

                <p>
                    Nagpur district open and women's Chess Championship organised by Chess Association Nagpur in association with G H Raisoni Sports and cultural foundation and Kalpana Prakash Welfare foundation
                </p>
                <p>
                    Ayush Ramteke in Open Group and  Rashmika Maringanti  in Women’s Group Annexed the Titles of the  Nagpur District Open and Women’s Chess Championship organized by Chess Association Nagpur in association with Cultural Foundation and Kalpana Prakash Welfare Foundation at Vivekanand Hall, Shraddha House, Kingsway, Near Kasturchand Park, Nagpur which was organised on 04th February 2024.
                    Ayush Ramteke scored 5.5 out of 6 defeating Mayank Hedau 4 out of 6 on the second board in the last round ,while Sai Sharma 5 out of 6 drew against Rushikesh lohit 5.5 out 6 on the top board. After the tie break Ayush emerged as champion.

                </p>
                <p> In the Women’s category Rashmika Maringanti 5.5 out 6 Drew against top seeded Shweta Gole 4.5 on the top board. On the second board Swara Gandhi 4.5 out 6 drew against Aparnita Jagtap 4.5. With a half point lead Rashmika emerged as Champion.For development of players Chess Association Nagpur shall be conducting a Grandmaster Coaching camp of all the Nagpur District selection champions.</p>
                <strong>Date :</strong>  4<sup>th</sup> February 2024  <br>
                <strong>Venue :</strong> Vivekanand Hall, Shraddha House, kingsway Near Kasturchand Park.
            </div>

            <div class="border-line-sm"></div>
            <div class="col-lg-12">
                <ul class="list-style list-style1">

                    <li>
                        <strong> Open Group top 10</strong> :
                        <ul class="column-count">
                            <li>1<sup>st</sup> Ramteke, Ayush</li>
                            <li>2<sup>nd</sup> Lohit, Rushikesh</li>
                            <li>3<sup>rd</sup> Ramteke, Sumedh</li>
                            <li>4<sup>th</sup> Sharma, Sai</li>
                            <li>5<sup>th</sup> Kushagra, Paliwal</li>
                            <li>6<sup>th</sup> Dutta, Kanishq</li>
                            <li>7<sup>th</sup> Bhagchandani, Mohak</li>
                            <li>8<sup>th</sup> Mayank, Santosh Hedau</li>
                            <li>9<sup>th</sup> Chandrashekhar, Sable</li>
                            <li>10<sup>th</sup> Vivek, Deshmukh</li>
                        </ul>
                    </li>
                </ul>
                <div class="border-line-sm"></div>
                <ul class="list-style list-style1">

                    <li>
                        <strong> Women’s Group top 10</strong> :
                        <ul class="column-count">
                            <li>1<sup>st</sup> Rashmika, Maringanti</li>
                            <li>2<sup>nd</sup> Swara, Rahul Gandhi</li>
                            <li>3<sup>rd</sup>  Shweta, Gole</li>
                            <li>4<sup>th</sup> Jagtap, Aparnita</li>
                            <li>5<sup>th</sup> Amulyaa, Vikas Chaudhari</li>
                            <li>6<sup>th</sup> Zade, Chhavi</li>
                            <li>7<sup>th</sup> Pooja, Rakshak</li>
                            <li>8<sup>th</sup> Yashika, Amit Musale</li>
                            <li>9<sup>th</sup> Lakshita, Kranti Rathod</li>
                            <li>10<sup>th</sup>Vishwaja, Deshmukh</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="border-line-sm"></div>
            <div class="col-lg-12">

                <p>
                    Top 4 players in Open and Women’s group shall be representing Nagpur district in Maharashtra state Open and Women’s chess Championship this year.Prizes were distributed at the hands of former Sr. Branch Manager Union Bank of India Shri.Ghanshyamdas Mundra.
                </p>
                <p>
                    Bhushsan Shriwas, Secretary, Chess Association Nagpur and Kalpana Prakash Welfare Foundation, Chief Arbiter FA Shiva Iyer were present on the dias. Top Ten finishers in Open ad Girls group were awarded trophies and medals. Medals were also given to top two finishers in Under-15,13, 11, 9 and 7 age categories.

                </p>
                <p> Also, Result add to the PDF </p>

            </div>
            <div class="border-line-sm"></div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Open Selection</h4>
                            </div>
                        </div>
                    </div>
                    <iframe width="100%" height="330"
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/open-selection+chess-hampionship-prize-list.pdf" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>

                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Women’s Selection</h4>
                            </div>
                        </div>
                    </div>
                    <iframe width="100%" height="330"
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/women-selection-chess-hampionship+prize-list.pdf" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>

                </div>
            </div>
		</div>

	</div>

</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="border-line-sm"></div>
		<div class="row row-cols-1 row-cols-md-2">

			<div class="col">
				<div class="gall-ery">
					<div class="row">
						<div class="col-md-8">
							<div class="widget_title inner-title gall-sys shadow-text-sm">
								<h4 class="fw-bold">Photos</h4>
							</div>
						</div>
						<div class="col-md-4 text-end">
							<!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
									View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
							</a> -->
						</div>
					</div>
					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-championship/chess1.avif"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-championship/chess1.avif">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-championship/chess1.avif"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-championship/chess2.avif"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-championship/chess2.avif">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-championship/chess2.avif"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-championship/chess3.avif"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-championship/chess3.avif">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-championship/chess3.avif"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

	</div>
</section>
